<div class="card">
    @if(data.hasValue()){ 
        <!-- Tabla cuando ya tiene datos obtenidos -->
        <table-dynamic 
            [config]="{
                title: 'Table Test',
                columns: cols(),
                data: data.value() || [],
                totalRecords: totalRecords(),
                first: first(),
                pageSize: pageSize(),
                showFilters: true,
                selectable: true,
                exportable: true,
                globalFilterFields: [],
                loading: data.isLoading(),
            }"
            [actionButtons]="actionButtons()"
            (onDelete)="delete($event)"
            (onDeleteAll)="deleteAll($event)"
            (onEdit)="edit($event)"
            (onNew)="openNew()"
            (onPageChange)="onPageChange($event)"
            (onLazyLoad)="onLazyLoad($event)"
            (onCustomAction)="customAction($event)"
            (onSearch)="onSearch($event)"
            ></table-dynamic>
    }
    @else {
        <!-- Skeleton para cuando inicia y se esta cargando la data -->
        <table-skeleton
            [config]="{
                title: 'Table Test',
                columns: cols(),
                data: data.value() || [],
                totalRecords: 10,
                first: 0,
                pageSize: 5,
                showFilters: true,
                selectable: true,
                exportable: true,
            }"
        ></table-skeleton>
    }
    
    <!-- Dialogo de confirmacion y toast para feedback al usuario -->
    <p-confirmDialog />
    <p-toast />
    
    @if(dataLoaded() && selected() && fieldConfig()){
        <!-- Modal para editar o crear un item -->
        <modal-basic 
            [buttonsConfig]="buttonsConfig()"
            [dialog]="dialog()"
            [item]="selected()"
            [fieldConfig]="fieldConfig()"
            [title]="selected()?.id ? 'Editar' : 'Nuevo'"
            (onHide)="hideDialog()"
            (onSave)="save($event)"
        />
    }
</div>


